import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconHeadlineStyle0 = gravityIconIndividualCss;

const GravityIconHeadline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'd653b92addf996c8ffdc67736ef7a0c3806b1706', color: this.color, size: this.size }, h("svg", { key: 'e816801e50b04475aaff09a337b7a5c94c234b7c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd5fb3c0fe49f3547f287ef4a40a489ecbab50702', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.55 4.007a.5.5 0 0 0-.5.5v12.986a.5.5 0 0 0 .5.5h1.952a.5.5 0 0 0 .5-.5v-5.506h4.008v5.506a.5.5 0 0 0 .5.5h1.951a.5.5 0 0 0 .5-.5V4.507a.5.5 0 0 0-.5-.5h-1.95a.5.5 0 0 0-.5.5v4.82H6v-4.82a.5.5 0 0 0-.5-.5H3.55Zm15.4 5.592a.5.5 0 0 0-.5-.5h-1.445a1 1 0 0 0-.668.256l-2.012 1.807a.5.5 0 0 0-.046.697l.472.552a.5.5 0 0 0 .69.068l.412-.325a8.41 8.41 0 0 0 .395-.375 4.14 4.14 0 0 0 .374-.415 7.473 7.473 0 0 0-.041.56l-.042.832v4.737a.5.5 0 0 0 .5.5h1.41a.5.5 0 0 0 .5-.5V9.6Z", fill: "currentColor" }))));
    }
};
GravityIconHeadline.style = GravityIconHeadlineStyle0;

export { GravityIconHeadline as gravity_icon_headline };

//# sourceMappingURL=gravity-icon-headline.entry.js.map